const FORMAT_PDF = "pdf";
const FORMAT_CSV = "csv";

const triggerBrowserDownload = (url, fileName) => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName || "report";
  anchor.rel = "noopener";
  anchor.target = "_blank";
  anchor.click();
};

export const openGeneratedCustomReportFile = ({
  downloadUrl,
  fileName,
  format,
} = {}) => {
  if (!downloadUrl) {
    return;
  }

  if (format === FORMAT_PDF) {
    window.open(downloadUrl, "_blank", "noopener,noreferrer");
    return;
  }

  triggerBrowserDownload(
    downloadUrl,
    fileName || (format === FORMAT_CSV ? "report.csv" : "report")
  );
};
